import * as actionTypes from "./actionTypes";

export const getListCampaignAction = params => ({
	type: actionTypes.GET_LIST_CAMPAIGN_ACTION,
	params
});

export const getListCampaignSplashAction = params => ({
	type: actionTypes.GET_LIST_CAMPAIGN_SPLASH_ACTION,
	params
});

export const setListCampaignAction = params => ({
	type: actionTypes.SET_LIST_CAMPAIGN_ACTION,
	params
});

export const getCampaignDetailAction = params => ({
	type: actionTypes.GET_CAMPAIGN_DETAIL_ACTION,
	params
});

export const setCampaignDetailAction = params => ({
	type: actionTypes.SET_CAMPAIGN_DETAIL_ACTION,
	params
});

export const getLoyaltyDetailAction = params => ({
	type: actionTypes.GET_LOYALTY_DETAIL_ACTION,
	params
});

export const setLoyaltyDetailAction = params => ({
	type: actionTypes.SET_LOYALTY_DETAIL_ACTION,
	params
});

export const getMerchandisingDetailAction = params => ({
	type: actionTypes.GET_MERCHANDISING_DETAIL_ACTION,
	params
});

export const setMerchandisingDetailAction = params => ({
	type: actionTypes.SET_MERCHANDISING_DETAIL_ACTION,
	params
});

export const getLoyaltyPointDetailAction = params => ({
	type: actionTypes.GET_LOYALTY_POINT_DETAIL_ACTION,
	params
});

export const setLoyaltyPointDetailAction = params => ({
	type: actionTypes.SET_LOYALTY_POINT_DETAIL_ACTION,
	params
});

export const setMenuPromotionAction = params => ({
	type: actionTypes.SET_MENU_PROMOTION_ACTION,
	params
});
